import type { Preview3DConfig } from './preview3d'
import { PREVIEW_MATERIAL_CANVAS_WOOD } from './preview3d.material.canvas'
import { PREVIEW_MATERIAL_ALU_DIBOND } from './preview3d.material.alu'

export const PREVIEW_MATERIAL_CONFIGS: Record<string, Partial<Preview3DConfig>> = {
  canvasWood: PREVIEW_MATERIAL_CANVAS_WOOD,
  aluDibond: PREVIEW_MATERIAL_ALU_DIBOND,
  acrylglas: {
    defaultMaterialMode: 'alu',
    defaultShowFrame: false,
    aluDepth: 0.01,
    roundedRadius: 0.004,
    roundedSegments: 8,
    studioPlaneScale: 1.16,
  },
  hartschaum: {
    defaultMaterialMode: 'alu',
    defaultShowFrame: false,
    aluDepth: 0.015,
    roundedRadius: 0.003,
    roundedSegments: 6,
    studioPlaneScale: 1.17,
  },
  leichtschaum: {
    defaultMaterialMode: 'alu',
    defaultShowFrame: false,
    aluDepth: 0.012,
    roundedRadius: 0.003,
    roundedSegments: 6,
    studioPlaneScale: 1.18,
  },
  leinwand: {
    defaultMaterialMode: 'canvas',
    defaultShowFrame: true,
    wrapDepth: 0.024,
    barWidth: 0.05,
    stretcherDepth: 0.03,
    wrapBackExtra: 0.015,
    canvasFrontThick: 0.012,
    roundedRadius: 0.006,
    roundedSegments: 6,
    studioPlaneScale: 1.14,
  },
  holzdruck: {
    defaultMaterialMode: 'alu',
    defaultShowFrame: false,
    aluDepth: 0.018,
    roundedRadius: 0.002,
    roundedSegments: 4,
    studioPlaneScale: 1.15,
  },
  bristolkarton: {
    defaultMaterialMode: 'alu',
    defaultShowFrame: false,
    aluDepth: 0.004,
    roundedRadius: 0.001,
    roundedSegments: 4,
    studioPlaneScale: 1.12,
  },
  metallicShine: {
    defaultMaterialMode: 'alu',
    defaultShowFrame: false,
    aluDepth: 0.007,
    roundedRadius: 0.003,
    roundedSegments: 8,
    studioPlaneScale: 1.14,
  },
}

export function getPreview3dMaterialPreset(key: unknown): Partial<Preview3DConfig> {
  const normalized = String(key || '')
    .trim()
    .toLowerCase()
    .replace(/[_\s]+/g, '-')

  const aliases: Record<string, string> = {
    'canvas-wood': 'canvasWood',
    'leinwand': 'leinwand',
    'acrylglas': 'acrylglas',
    'alu-dibond': 'aluDibond',
    'aludibond': 'aluDibond',
    'foto-auf-hartschaum': 'hartschaum',
    'hartschaum': 'hartschaum',
    'foto-auf-leichtschaum': 'leichtschaum',
    'leichtschaum': 'leichtschaum',
    'holzdruck': 'holzdruck',
    'bristolkarton': 'bristolkarton',
    'metallic-shine': 'metallicShine',
    'metallicshine': 'metallicShine',
  }

  const resolvedKey = aliases[normalized] || String(key || '').trim()
  return PREVIEW_MATERIAL_CONFIGS[resolvedKey] || {}
}
